import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { OwnersDisplayGridRowDataFragmentGql } from './OwnersDisplayGridRowFragmentGql';

// Should fetch same nodes as TableDownstreamOwnerIdsQuery
export const TableDownstreamOwnersQueryGql: DocumentNode = gql`
query TableDownstreamOwnersQuery($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  tables(filter: { id: $tableId }) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowDataFragment
      }
    }
  }
}
${OwnersDisplayGridRowDataFragmentGql}
`;
